import PropTypes from "prop-types";

export default function Badge({
  size,
  textSize,
  bgColor,
  children,
  className,
  borderColor,
  ...props
}) {
  return (
    <>
      <span
        className={`bold badge--${size} label label--${
          size === "sm" ? "sm" : "md"
        } tc-white bc-${bgColor} ${className} ${
          borderColor && `border-${borderColor}`
        }`}
        {...props}
      >
        {children}
      </span>
      <style jsx>{`
        .badge--lg {
          padding: 6px;
          border-radius: 4px;
        }
        .badge--sm {
          padding: 2px 4px;
          border-radius: 2px;
        }
        .align-left {
          position: absolute;
          top: 12px;
          left: 12px;
        }
        .align-topRight {
          position: absolute;
          top: -10px;
          right: 14px;
          z-index: 2;
        }
        .sub-integ-tile-badge {
          color: #707477;
          position: absolute;
          top: -15px;
          left: 20px;
        }
        .border-grey {
          border: 2px solid #e2e2e7;
        }
      `}</style>
    </>
  );
}

Badge.defaultProps = {
  size: "lg",
  bgColor: "grad-purple",
  textSize: "md",
  className: "",
  borderColor: "",
};

Badge.propTypes = {
  size: PropTypes.string,
  bgColor: PropTypes.string,
  textSize: PropTypes.string,
  className: PropTypes.string,
  borderColor: PropTypes.string,
};
